/**
 * Person-owned WIP files show a first name (for example "William") next to the avatar.
 */

export function firstNameFromDisplayName(displayName: string | null | undefined, email: string | null | undefined): string {
  const name = displayName?.trim() ?? "";
  if (name !== "") {
    const first = name.split(/\s+/).find((part) => part.length > 0);
    if (first) return first;
  }
  const local = (email ?? "").split("@")[0]?.trim() ?? "";
  if (local === "") return "Unknown";
  return local;
}

export function isPersonOwnedWipDocument(document: {
  owner_user_id?: string | null;
  targets?: Array<{ target_type: string; sku?: string | null; product_collection_id?: string | null }> | null;
  sku?: string | null;
  product_family_id?: string | null;
}): boolean {
  const ownerId = document.owner_user_id?.trim() ?? "";
  if (ownerId === "") return false;
  const targets = document.targets ?? [];
  const hasTarget = targets.some((target) => {
    if (target.target_type === "sku" && target.sku?.trim()) return true;
    if (target.target_type === "collection" && target.product_collection_id?.trim()) return true;
    return false;
  });
  if (hasTarget) return false;
  if (document.sku?.trim()) return false;
  if (document.product_family_id?.trim()) return false;
  return true;
}
